import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import Header from "../Header";
import AppContext from "../../../contexts/AppContext";
import { register } from "../../../services/user";
import { externalEmp } from "../../../services/externalEmployee";
import "./RegisterTab.css";

export class EmployerForm extends Component {
    state = {
        item: {
            type: "employer",
            external: false,
            externalId: null,
            full_name:'',
            email:'',
            password:'',
            send_free_email: true,
        },
        readOnly: false,
        errors: {},
        loading: false,
    };

    toggleChange = () => {
        this.setState({
            send_free_email: !this.state.send_free_email,
        });
      }

    onChange = field => {
        let temp = this.state.item;
        temp[field.target.name] = field.target.value;

        let error = this.state.errors;
        error[field.target.name] = null;

        this.setState({ item: temp, errors: error });
        if(field.target.name == 'send_free_email'){
            this.state.item.send_free_email = ! this.state.item.send_free_email;
        }
    };
    submitRegister = e => {
        e.preventDefault();
        this.setState({ loading: true });
        register(this.state.item)
            .then(res => {
                this.setState({ loading: false });
                localStorage.setItem("auth_token", res.meta.token);
                localStorage.setItem(
                    "applications",
                    JSON.stringify(res.data.applications)
                );
                localStorage.setItem("alerts", null);
                localStorage.setItem("welcome", null);
                localStorage.setItem("user", JSON.stringify(res.data));
                localStorage.removeItem("new_subscriber");
                if (res.meta.token) {
                    const nextRoute = new URLSearchParams(window.location.search);
                    if(nextRoute.get('next') == 'post-job'){
                        window.location = "/employer/jobListing/create";
                    }else{
                        window.location = "/employer/account";
                    }
                }
            })
            .catch(error => {
                this.setState({ loading: false });
                switch (error.response.status) {
                    case 422:
                        this.setState({
                            errors: error.response.data.error
                        });
                        break;
                    default:
                        this.context.state.handelError(error);
                        break;
                }
            });
    };
    componentDidMount() {
        this.nameInput.focus();
        this.setState({ readOnly: false });
        let path = window.location.pathname;
        let external_emp = path.split('/register/employer/')[1];
        //console.log(external_emp);
        if (external_emp !== null && external_emp != undefined) {
            let empId = external_emp.split('-')[3];
            externalEmp(empId)
                .then(res => {
                    let temp = this.state.item;
                    temp['company_name'] = res.data.company_name;
                    temp['externalId'] = empId;
                    temp['external'] = true;
                    this.setState({ item: temp });
                })
                .catch(error => {
                    this.context.state.handelError(error);
                });

            this.setState({ readOnly: true });
        }


        let error = this.state.errors;
        error['company_name'] = null;
        this.setState({ errors: error });
    }

    render() {
        return (
            <Fragment>

                <form
                    onSubmit={this.submitRegister}
                    method="POST"
                >
                    <div className="form-group mb-3">
                        <input
                            ref={input => {
                                this.nameInput = input;
                            }}
                            id="full_name"
                            type="text"
                            placeholder="Enter Your Full Name..."
                            className={
                                this.state.errors.full_name
                                    ? "is-invalid form-control  form-control-large"
                                    : " form-control  form-control-large"
                            }
                            name="full_name"
                            autoComplete="off"
                            onChange={this.onChange}
                        />
                        {this.state.errors.full_name ? (
                            <div className="invalid-feedback">
                                {
                                    this.state.errors
                                        .full_name
                                }
                            </div>
                        ) : null}

                        {/* <div className="col-12 col-md-6">
                                            <input
                                                id="last_name"
                                                type="text"
                                                className={
                                                    this.state.errors.last_name
                                                        ? "is-invalid form-control  form-control-large"
                                                        : " form-control  form-control-large"
                                                }
                                                name="last_name"
                                                autoComplete="off"
                                                onChange={this.onChange}
                                            />
                                            {this.state.errors.last_name ? (
                                                <div className="invalid-feedback">
                                                    {
                                                        this.state.errors
                                                            .last_name
                                                    }
                                                </div>
                                            ) : null}
                                        </div> */}
                    </div>
                    {/* <div className="form-group row">
                                        <div className="col-12 col-md-12  ">
                                            <label
                                                className="bold"
                                                htmlFor="company_name"
                                            >
                                                Company name
                                            </label>


                                            <input
                                                id="company_name"
                                                type="text"
                                                defaultValue={this.state.item.company_name || ''}
                                                className={
                                                    this.state.errors
                                                        .company_name
                                                        ? "is-invalid form-control  form-control-large"
                                                        : " form-control  form-control-large"
                                                }
                                                name="company_name"
                                                autoComplete="off"
                                                readOnly = { this.state.item.external }
                                            />

                                            {this.state.errors.company_name ? (
                                                <div className="invalid-feedback">
                                                    {
                                                        this.state.errors
                                                            .company_name
                                                    }
                                                </div>
                                            ) : null}
                                        </div>
                                    </div> */}
                    <div className="form-group mb-3">
                        <input
                            onChange={this.onChange}
                            type="text"
                            placeholder="Enter Your Email Address..."
                            className={
                                this.state.errors.email
                                    ? "is-invalid form-control  form-control-large"
                                    : " form-control  form-control-large"
                            }
                            name="email"
                            autoComplete="off"
                            id="email"
                        />
                        {this.state.errors.email ? (
                            <div className="invalid-feedback">
                                {this.state.errors.email}
                            </div>
                        ) : null}
                    </div>
                    <div className="form-group mb-3">
                        <input
                            onChange={this.onChange}
                            type="password"
                            name="password"
                            placeholder="Create Your Password"
                            id="password"
                            className={
                                this.state.errors.password
                                    ? "is-invalid form-control  form-control-large"
                                    : " form-control  form-control-large"
                            }
                        />
                        {this.state.errors.password ? (
                            <div className="invalid-feedback">
                                {this.state.errors.password}
                            </div>
                        ) : null}
                    </div>
                    <div className="form-group">
                           <label className="custom-checkbox">
                            <div>
                              <input type="checkbox"  id="send_free_email" name="send_free_email" defaultChecked={this.state.item.send_free_email} onChange={this.onChange} />
                            </div>
                            <span className="text-grey">Send me your free writer hiring education emails.</span>
                           </label>
                    </div>
                    <button disabled={this.state.loading} className="bold form-control-large btn btn-lg btn-block btn-primary mb-3 mt-4 mx-auto py-3">
                    <i className={this.state.loading ? `mr-2 fas fa-spinner fa-spin` : ``}></i> {this.state.loading ? `Submitting...` : `Register`}
                    </button>
                    <small className="text-center text-grey d-block"><i className="fa fa-lock mr-2"></i>By providing us with your information you are consenting to the collection and use of your information in accordance with our <a href="https://www.iubenda.com/privacy-policy/72278847">Privacy Policy.</a></small>
                    {/* <div className="text-muted auth-text-muted text-center pt-3">
                                        Register as a{" "}
                                        <Link to={`/register/`}>Writer</Link>
                                    </div>
                                    <p></p> */}
                </form>


            </Fragment>
        );
    }
}

EmployerForm.contextType = AppContext;
export default EmployerForm;



// WEBPACK FOOTER //
// ./src/components/auth/register/EmployerForm.js